const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'ptype_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_PTYPES':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_PTYPES':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_PTYPES':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_PTYPES':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_PTYPE':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.ptype_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ptypes.js